import React, { useEffect } from "react";
import { useField } from "react-final-form";
import { required, TextInput } from "react-admin";

interface ICommercialDocumentNoteInput {
  label: string;
  source: string;
  rateChartSource: string;
  rateChartId: any;
}

const CommercialDocumentNoteInput = ({
  label,
  source,
  rateChartSource,
  rateChartId,
}: ICommercialDocumentNoteInput) => {
  const noteField = useField(source);
  const rateChartField = useField(rateChartSource);

  useEffect(() => {
    noteField.input.onChange(null);
    rateChartField.input.onChange(rateChartId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TextInput
      label={label}
      source={source}
      onChange={(e: any) => {
        rateChartField.input.onChange(rateChartId);
      }}
      validate={required()}
    />
  );
};

export default CommercialDocumentNoteInput;
